export const theme = {
  screens: { md: "48rem", lg: "64rem" },
  testimonialDimensions: {
    square: {
      width: "380",
      height: "380",
    },
  },
}

export const customMedia = {
  "--media-sm-only": `screen and (max-width: calc(${theme.screens.md} - 1px))`,
  "--media-md": `screen and (min-width: ${theme.screens.md})`,
  "--media-lg": `screen and (min-width: ${theme.screens.lg})`,
}

export default { theme, customMedia }
